<template>
  <pt-all-order-list class="pt-all-order-list__withData" @exportAllOrder="exportAllOrder" ref="table" :pageSize="pageSize" :exportLoading="exportLoading"
                     :groupList="groupList" :goodsTypeList="goodsTypeList" :vendorsOrganizations="vendorsOrganizations"
                     :operationalPromotions="operationalPromotions" :orderOrganization="orderOrganization"></pt-all-order-list>
</template>

<script>
import PtAllOrderList from './index'
export default {
  name: 'pt-all-order-list__withData',
  components: {
    'pt-all-order-list': PtAllOrderList
  },
  data () {
    return {
      pageSize: 30,
      exportLoading: false,
      groupList: [],
      goodsTypeList: [],
      vendorsOrganizations: [],
      operationalPromotions: [],
      orderOrganization: []
    }
  },
  methods: {
    exportAllOrder (val) {
      let data = {
        ...val,
        pageable: {
          sort: 'createdDate,desc'
        }
      }
      this.exportLoading = true
      this.$store.dispatch('exportAllOrder', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出订单失败')
      })
    },
    // 获取商品分组列表
    getGroupList () {
      let data = {
        pageable: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('groupWithGoodsCount', data).then(res => {
        this.groupList = res.data
      }).catch(err => {
        this.$message.error(err || '获取商品分组失败')
      })
    },
    // 获取商品类型列表
    getGoodsTypes () {
      this.$store.dispatch('getGoodsTypes').then(res => {
        this.goodsTypeList = res
      }).catch(err => {
        this.$message.error(err || '获取商品类型失败')
      })
    },
    // 获取第三方供应商列表
    getVendorsOrganizations () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getVendorsOrganizations', data).then(res => {
        this.vendorsOrganizations = res
      }).catch(err => {
        this.$message.error(err || '获取第三方供应商列表失败')
      })
    },
    // 运营活动的促销活动
    getOperationalPromotion () {
      this.$store.dispatch('getOperationalPromotion').then(res => {
        this.operationalPromotions = res
      }).catch(err => {
        this.$message.error(err || '获取运营活动失败')
      })
    },
    // 获取分子公司列表
    getorderOrganization () {
      let data = {
        pageableParam: {
          page: 0,
          size: 9999
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        this.orderOrganization = res.data
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    }
  },
  created () {
    this.getGroupList()
    this.getGoodsTypes()
    this.getVendorsOrganizations()
    this.getOperationalPromotion()
    this.getorderOrganization()
  }
}
</script>
